export default "__VITE_PUBLIC_ASSET__7520012a__"